export enum ERRORS_ENUM {
  NOT_AUTHORISED = 403,
  NOT_FOUND = 404,
  NOT_MAPPED = 'not_mapped_code',
  USER_NOT_LOGGED = 'user_not_logged',
  TOGGLE_OFF = 'toggle_off_code',
}

export enum ROUTE_GROUPS_ENUM {
  DEFAULT = 'standard',
  APPLICATIONS = 'applications',
  ESIS = 'esis',
  NETWORKS = 'networks',
  FIRMS = 'firms',
  CLUBS = 'clubs',
  ADMINS = 'admins',
  ADVISORS = 'advisors',
  MBC = 'mbc',
  FMA = 'fma',
  AF_TOOL = 'af_tool',
  CM = 'cm',
  GUIDES = 'guides',
  COMMISSION_TERMS = 'commission_terms',
  QUOTE = 'quote',
  USER = 'user',
  REGISTER = 'register',
}

export enum PAGES_ENUM {
  DASHBOARD = 'DASHBOARD',
  TRIAGE = 'TRIAGE',
  PROFILE = 'PROFILE',
  APPLICATION_FLOW = 'APPLICATION_FLOW',
  QUICK_ESIS_FLOW = 'QUICK_ESIS_FLOW',
  REGISTER_ADVISER_AND_SUPPORT = 'REGISTER_ADVISER_AND_SUPPORT',
  REGISTER_FIRM_AND_MANAGER = 'REGISTER_FIRM_AND_MANAGER',
  MANAGERS_LIST = 'MANAGERS_LIST',
  ADVISERS_LIST = 'ADVISERS_LIST',
  FIRMS_LIST = 'FIRMS_LIST',
  NETWORKS_LIST = 'NETWORKS_LIST',
  CLUBS_LIST = 'CLUBS_LIST',
  APPLICATION_LIST = 'APPLICATION_LIST',
  APPLICATION_SUMMARY = 'APPLICATION_SUMMARY',
  BLANK = 'BLANK',
  PRODUCT_RESELECT = 'PRODUCT_RESELECT',
  ADMIN_PANEL = 'ADMIN_PANEL',
  MBC = 'MBC',
  FMA = 'FMA',
  AF_TOOL = 'AF_TOOL',
  CASE = 'CASE',
  REGISTER = 'REGISTER',
  ORGANIZATION_DETAILS = 'ORGANIZATION_DETAILS',
}

export enum PERMISSION_ENUM {
  APPLICATION = 'APPLICATION',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  PLACEHOLDER = 'PLACEHOLDER',
  USER = 'USER',
  USER_FIRM = 'USER_FIRM',
  USER_FIRM_SUPPORT = 'USER_FIRM_SUPPORT',
  USER_SUPPORT = 'USER_SUPPORT',
  USER_NETWORK = 'USER_NETWORK',
  USER_CLUB = 'USER_CLUB',
  STANDARD = 'STANDARD',
  ALLOW_TO_NON_ACTIVE = 'ALLOW_TO_NON_ACTIVE',
  VIEW_UPLOAD_EDIT = 'VIEW_UPLOAD_EDIT',
  SUPPORTIVE = 'SUPPORTIVE',
  NOT_LOGGED = 'NOT_LOGGED',
  VIEW_APP_VERIFICATION_SUMMARY = 'VIEW_APP_VERIFICATION_SUMMARY',
  FINANCIAL_USER = 'VIEW_AF_DELPHI_VERIFICATION',
  WRITE = 'WRITE',
  DUE_DILIGENCE_FIRST_LINE = 'DUE_DILIGENCE_FIRST_LINE',
  DUE_DILIGENCE_SECOND_LINE = 'DUE_DILIGENCE_SECOND_LINE',
}

export enum AVAILABLE_PAGES_ENUM {
  DASHBOARD = 'DASHBOARD',
  TRIAGE = 'TRIAGE',
  PROFILE = 'PROFILE',
  CASE_MANAGEMENT = 'cm',
  APPLICATIONS_LIST = 'APPLICATIONS_LIST',
  APPLICATIONS_SUMMARY = 'APPLICATIONS_SUMMARY',
  APPLICATIONS_SINGLE_APPLICATION_SUBMITTED = 'APPLICATIONS_SINGLE_APPLICATION_SUBMITTED',
  ESIS_LIST = 'ESIS_LIST',
  NETWORK_REGISTER_STEP_1 = 'NETWORK_REGISTER_STEP_1',
  NETWORK_LIST = 'NETWORK_LIST',
  NETWORK_DETAIL = 'NETWORK_DETAIL',
  CLUBS_LIST = 'CLUBS_LIST',
  CLUBS_DETAIL = 'CLUBS_DETAIL',
  CLUBS_REGISTER_STEP_1 = 'CLUBS_REGISTER_STEP_1',
  FIRMS_LIST = 'FIRMS_LIST',
  FIRMS_DETAIL = 'FIRMS_DETAIL',
  FIRM_MANAGERS = 'FIRM_MANAGERS',
  ADMINS_LIST = 'ADMINS_LIST',
  ADMINS_DETAIL = 'ADMINS_DETAIL',
  ADMINS_COMPANY_DETAILS = 'ADMINS_COMPANY_DETAILS',
  ADMINS_REGISTER = 'ADMINS_REGISTER',
  ADVISOR_SEARCH = 'ADVISOR_SEARCH',
  ADVISOR_ADD = 'ADVISOR_ADD',
  ADVISOR_ADD_SUCCESS = 'ADVISOR_ADD_SUCCESS',
  ADVISOR_LIST = 'ADVISOR_LIST',
  ADVISOR_DETAIL = 'ADVISOR_DETAIL',
  FMA_CREATE = 'FMA_CREATE',
  FMA_EDIT = 'FMA_EDIT',
  FMA_REDIRECT_TO_STEP = 'FMA_REDIRECT_TO_STEP',
  AF_TOOL = 'AF_TOOL',
  AF_TOOL_FORM_PAGE = 'AF_TOOL_FORM_PAGE',
  QUOTE_SUMMARY = 'QUOTE_SUMMARY',
  CM_INDEX = 'CM_INDEX',
  CM_CASE_BY_ID = 'CM_CASE_BY_ID',
  GUIDES = 'GUIDES',
  COMMISSION_TERMS_INDEX = 'COMMISSION_TERMS_INDEX',
  COMMISSION_TERMS_CREATE = 'COMMISSION_TERMS_CREATE',
  COMMISSION_TERMS_EDIT = 'COMMISSION_TERMS_EDIT',
  QUOTE_INITIAL = 'QUOTE_INITIAL',
  QUOTE_DETAILS = 'QUOTE_DETAILS',
  QUOTE_PRODUCT_SELECTION = 'QUOTE_PRODUCT_SELECTION',
  QUOTE_SUMMARY_PAGE = 'QUOTE_SUMMARY_PAGE',
  USER_EDIT = 'USER_EDIT',
  REGISTER = 'REGISTER',
  REGISTER_SET_PASSWORD = 'REGISTER_SET_PASSWORD',
  REGISTER_VERIFY = 'REGISTER_VERIFY',
}
